"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccountInfo = exports.getTokenAccount = exports.getAssociatedTokenAddress = exports.convertFactionStringToNum = exports.longToByteArray = exports.byteArrayToLong = exports.stringToByteArray = exports.byteArrayToString = void 0;
const __1 = require("..");
const anchor_1 = require("@project-serum/anchor");
const web3_js_1 = require("@solana/web3.js");
const spl_token_1 = require("@solana/spl-token");
function byteArrayToString(array) {
    return String.fromCharCode(...array);
}
exports.byteArrayToString = byteArrayToString;
function stringToByteArray(str, length) {
    if (str.length > length) {
        return null;
    }
    let byteArray = [];
    for (let i = 0; i < length; i += 1) {
        let code = 32;
        if (i < str.length) {
            code = str.charCodeAt(i);
        }
        byteArray = byteArray.concat([code]);
    }
    return byteArray;
}
exports.stringToByteArray = stringToByteArray;
function byteArrayToLong(byteArray) {
    let value = 0;
    for (let i = byteArray.length - 1; i >= 0; i -= 1) {
        value = value * 256 + byteArray[i];
    }
    return value;
}
exports.byteArrayToLong = byteArrayToLong;
function longToByteArray(long) {
    const byteArray = [0, 0, 0, 0, 0, 0, 0, 0];
    for (let index = 0; index < byteArray.length; index += 1) {
        const byte = long & 0xff;
        byteArray[index] = byte;
        long = (long - byte) / 256;
    }
    return byteArray;
}
exports.longToByteArray = longToByteArray;
/**
 * Helper function to switch case string inputs for faction filter
 */
function convertFactionStringToNum(factionName) {
    return __awaiter(this, void 0, void 0, function* () {
        switch (factionName.toLowerCase()) {
            case 'mud':
                return __1.FactionType.MUD;
            case 'oni':
                return __1.FactionType.ONI;
            case 'ustur':
                return __1.FactionType.Ustur;
            default:
                return __1.FactionType.Unenlisted;
        }
    });
}
exports.convertFactionStringToNum = convertFactionStringToNum;
/**
 * Get associated token address
 *
 * @param owner - the public key that owns the associated token address
 * @param mint - the mint
 * @returns a promise of the associated token address
 */
function getAssociatedTokenAddress(owner, mint) {
    return __awaiter(this, void 0, void 0, function* () {
        const [address] = yield web3_js_1.PublicKey.findProgramAddress([owner.toBuffer(), spl_token_1.TOKEN_PROGRAM_ID.toBuffer(), mint.toBuffer()], spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID);
        return address;
    });
}
exports.getAssociatedTokenAddress = getAssociatedTokenAddress;
function getTokenAccount(connection, wallet, mint, newAccountFunder = wallet, amountNeededHeuristic) {
    return __awaiter(this, void 0, void 0, function* () {
        // Get all parsed token accounts for a given owner and mint
        const { value: tokenAccounts } = yield connection.getParsedTokenAccountsByOwner(wallet, { mint });
        let tokenAccount = null;
        if (amountNeededHeuristic === undefined) {
            let maxTokens = null;
            for (const account of tokenAccounts) {
                if (account.account.data.parsed.type === 'account') {
                    const parsedAccount = account.account.data.parsed;
                    const tokenAmount = new anchor_1.BN(parsedAccount.info.tokenAmount.amount);
                    if (maxTokens === null || tokenAmount.gt(maxTokens)) {
                        tokenAccount = account.pubkey;
                        maxTokens = tokenAmount;
                    }
                }
            }
        }
        else {
            let minTokens = null;
            for (const account of tokenAccounts) {
                if (account.account.data.parsed.type === 'account') {
                    const parsedAccount = account.account.data.parsed;
                    const tokenAmount = new anchor_1.BN(parsedAccount.info.tokenAmount.amount);
                    if (tokenAmount.gt(new anchor_1.BN(amountNeededHeuristic)) &&
                        (minTokens === null || tokenAmount.lt(minTokens))) {
                        tokenAccount = account.pubkey;
                        minTokens = tokenAmount;
                    }
                }
            }
        }
        if (tokenAccount === null) {
            const associatedTokenAddress = yield getAssociatedTokenAddress(wallet, mint);
            const { value: account } = yield connection.getParsedAccountInfo(associatedTokenAddress, 'confirmed');
            if (account === null || account.owner.equals(web3_js_1.SystemProgram.programId)) {
                return {
                    tokenAccount: associatedTokenAddress,
                    createInstruction: spl_token_1.Token.createAssociatedTokenAccountInstruction(spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID, spl_token_1.TOKEN_PROGRAM_ID, mint, associatedTokenAddress, wallet, newAccountFunder),
                };
            }
            if ('program' in account.data &&
                account.data.parsed.type === 'account' &&
                new web3_js_1.PublicKey(account.data.parsed.info.owner).equals(wallet)) {
                return {
                    tokenAccount: associatedTokenAddress,
                };
            }
            else {
                const newTokenAccount = anchor_1.web3.Keypair.generate();
                return {
                    tokenAccount: newTokenAccount,
                    createInstruction: spl_token_1.Token.createInitAccountInstruction(spl_token_1.TOKEN_PROGRAM_ID, mint, newTokenAccount.publicKey, wallet),
                };
            }
        }
        else {
            return {
                tokenAccount,
            };
        }
    });
}
exports.getTokenAccount = getTokenAccount;
function getAccountInfo(connection, account) {
    return __awaiter(this, void 0, void 0, function* () {
        const { value: accountInfo } = yield connection.getParsedAccountInfo(account);
        const someInfo = accountInfo.data;
        return someInfo;
    });
}
exports.getAccountInfo = getAccountInfo;
//# sourceMappingURL=helpers.js.map